import o from"styled-components";import{theme as r}from"../../../../../theme.js";const t=o.div`
  display: flex;
  gap: ${r.spacing*2}px;
  align-items: center;
  padding: ${r.spacing*2}px;
  border-radius: ${r.radius}px;
  background-color: ${r.colors.gray[100]};
  width: fit-content;
  > svg {
    width: 20px;
    height: 20px;
  }
  > span {
    font-size: 14px;
    line-height: 20px;
    color: ${r.colors.gray[900]};
    text-transform: lowercase;
  }
  > button {
    border: none;
    outline: none;
    width: 20px;
    height: 20px;
    padding: 0;
    margin: 0;
    border-radius: 50%;
    background-color: transparent;
    transition: all .1s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > svg {
      width: 16px;
      height: 16px;
      > g, path {
        fill: ${r.colors.gray[400]}
      }
    }
    &:hover {
      background-color: ${r.colors.gray[200]};
      > svg {
        > g, path {
          fill: ${r.colors.gray[500]};
        }
      }
    }
  }
`;export{t as Container};
